export const SHOW_NAVIGATION_MODAL = 'SHOW_NAVIGATION_MODAL';
export const HIDE_NAVIGATION_MODAL = 'HIDE_NAVIGATION_MODAL';

export const SHOW_SORT_PROVIDERS_MODAL = 'SHOW_SORT_PROVIDERS_MODAL';
export const HIDE_SORT_PROVIDERS_MODAL = 'HIDE_SORT_PROVIDERS_MODAL';

export const SHOW_BONUS_CONFIRM_BONUS_MODAL = 'SHOW_BONUS_CONFIRM_BONUS_MODAL';
export const HIDE_BONUS_CONFIRM_BONUS_MODAL = 'HIDE_BONUS_CONFIRM_BONUS_MODAL';

export const SHOW_CURRENCY_CONFIRM_MODAL = 'SHOW_CURRENCY_CONFIRM_MODAL';
export const HIDE_CURRENCY_CONFIRM_MODAL = 'HIDE_CURRENCY_CONFIRM_MODAL';

export const SHOW_RECENTS_GAMES_MIGRATION_PROCESS_MODAL =
  'SHOW_RECENTS_GAMES_MIGRATION_PROCESS_MODAL';
export const HIDE_RECENTS_GAMES_MIGRATION_PROCESS_MODAL =
  'HIDE_RECENTS_GAMES_MIGRATION_PROCESS_MODAL';

export const SHOW_LOSS_LIMITS_MODAL = 'SHOW_LOSS_LIMITS_MODAL';
export const HIDE_LOSS_LIMITS_MODAL = 'HIDE_LOSS_LIMITS_MODAL';
